import { Button, DialogActions, DialogContent, Divider, Link, Typography } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import { Stack } from '@mui/system';
import { Trans } from 'react-i18next';

interface BluetoothWarningDialogProps {
  open?: boolean;
  onClose: (event?: unknown, reason?: string) => void;
}

const BluetoothWarningDialog = ({ onClose }: BluetoothWarningDialogProps) => {
  const handleClose = () => {
    onClose(false);
  };

  return (
    <>
      <DialogTitle variant="sectionTitle" align="center">
        <Trans i18nKey="bluetoothWarningDialog.title">Incompatible Browser</Trans>
      </DialogTitle>
      <Divider />
      <DialogContent style={{ padding: '3rem 2.75rem' }}>
        <Stack direction="column" spacing={2} useFlexGap flexWrap="wrap">
          <Typography variant="body1" fontWeight={500}>
            <Trans i18nKey="bluetoothWarningDialog.explainer">
              Your browser does not support web Bluetooth, which is requires to conenct to Sphero robots.
            </Trans>
          </Typography>
          <Typography variant="body1" fontWeight={500}>
            <Trans i18nKey="bluetoothWarningDialog.infoPointer">Use the link below to learn more about compatibilty</Trans>
          </Typography>
          <Link href="https://help.sphero.com/sphero-support/blueprint-studio-compatibility" target="_blank" rel="noopener noreferrer">
            <Trans i18nKey="learn.more">Learn More</Trans>
          </Link>
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions style={{ margin: '2px 12px' }}>
        <Button variant="contained" autoFocus onClick={handleClose}>
          <Trans i18nKey="button.close">Close</Trans>
        </Button>
      </DialogActions>
    </>
  );
};

export default BluetoothWarningDialog;
